var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleSlides = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 40,
  viewBox: "0 0 29 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4298_3922)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_4298_3922",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 29,
  height: 40
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4298_3922)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L22.2581 6.27524L17.8065 0Z",
  fill: "#F4B400"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask1_4298_3922",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 29,
  height: 40
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "white"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_4298_3922)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.0323 17.9293H8.45806C7.72356 17.9293 7.12259 18.5344 7.12259 19.274V30.928C7.12259 31.6676 7.72356 32.2727 8.45806 32.2727H20.0323C20.7668 32.2727 21.3678 31.6676 21.3678 30.928V19.274C21.3678 18.5344 20.7668 17.9293 20.0323 17.9293ZM19.5871 28.2386H8.90323V21.9634H19.5871V28.2386Z",
  fill: "#F1F1F1"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask2_4298_3922",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 29,
  height: 40
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "white"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_4298_3922)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.5878 9.97092L28.4904 19.9396V10.7576L18.5878 9.97092Z",
  fill: "url(#paint0_linear_4298_3922)"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask3_4298_3922",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 29,
  height: 40
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "white"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_4298_3922)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0V8.0682C17.8065 9.55408 19.0018 10.7576 20.4775 10.7576H28.4904L17.8065 0Z",
  fill: "#FADA80"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask4_4298_3922",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 29,
  height: 40
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "white"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask4_4298_3922)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0V0.224116L28.2678 10.7576H28.4904L17.8065 0Z",
  fill: "white",
  fillOpacity: 0.1
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask5_4298_3922",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 29,
  height: 40
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "white"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask5_4298_3922)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.67097 0C1.20194 0 0 1.21023 0 2.68939V2.91351C0 1.43434 1.20194 0.224116 2.67097 0.224116H17.8065V0H2.67097Z",
  fill: "white",
  fillOpacity: 0.2
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask6_4298_3922",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 29,
  height: 40
}, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "white"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask6_4298_3922)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.8194 39.2203H2.67097C1.20194 39.2203 0 38.0101 0 36.5309V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V36.5309C28.4904 38.0101 27.2884 39.2203 25.8194 39.2203Z",
  fill: "#BF360C",
  fillOpacity: 0.2
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask7_4298_3922",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 29,
  height: 40
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "white"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask7_4298_3922)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.4775 10.7576C19.0018 10.7576 17.8065 9.55408 17.8065 8.0682V8.29228C17.8065 9.7782 19.0018 10.9817 20.4775 10.9817H28.4904V10.7576H20.4775Z",
  fill: "#BF360C",
  fillOpacity: 0.1
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8065 0H2.67097C1.20194 0 0 1.21023 0 2.68939V36.755C0 38.2342 1.20194 39.4444 2.67097 39.4444H25.8194C27.2884 39.4444 28.4904 38.2342 28.4904 36.755V10.7576L17.8065 0Z",
  fill: "url(#paint1_radial_4298_3922)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_4298_3922",
  x1: 23.5396,
  y1: 10.8268,
  x2: 23.5396,
  y2: 19.941,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BF360C",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BF360C",
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_4298_3922",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0.902591 0.784041) scale(45.9404 46.2572)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4298_3922"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 40,
  fill: "white"
})))));
export { SvgGoogleSlides as ReactComponent };
export default __webpack_public_path__ + "static/media/google-slides.93ef60a5.svg";